import * as React from 'react';
import {useHistory} from 'src/rerouter/index';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  ButtonTabs,
  ButtonTab,
} from '@spaced-out/ui-design-system/lib/components/index';


const EarningTabs = ({className}: {className?: string}) => {
  const {t} = useLabelTranslation();
  const router = useHistory();
  const {
    location: {pathname},
  } = router;

  let selectedTab = 'my-earnings';

  if (pathname === '/referralv2/earnings/payments') {
    selectedTab = 'payments';
  }

  return (
    <ButtonTabs
      classNames={{wrapper: className}}
      onButtonTabSelect={(value) =>
        router.push(`/referralv2/earnings/${value}`)
      }
      selectedButtonTabId={selectedTab}
    >
      <ButtonTab id="my-earnings">{t('My_Earnings', 'My Earnings')}</ButtonTab>
      <ButtonTab id="payments">
        {t('Payment_Method', 'Payment Method')}
      </ButtonTab>
    </ButtonTabs>
  );
};

export default EarningTabs;
